export default __webpack_public_path__ + "static/media/2b32cc80acd250b9ad412b4708062bd31581603232362.6bc33cf6.webp";